import * as React from "react";
import { useNavigate } from "react-router-dom";
import { connect } from 'react-redux';
import { fetchTipoUsuarios } from '../../actions/usuariosActions';
import GoBackArrow from "../General/GoBackArrow";
import { postTiposUsuarios } from "../../api/axios";
import { toast } from 'react-toastify';
import MiniSpinner from "../General/MiniSpinner";

function TipoUsuarioNuevoWrapper(props) {
    const navigate = useNavigate();
    return <TipoUsuarioNuevo {...props} navigate={navigate} />;
}

class TipoUsuarioNuevo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            descripcion: "",
            loading: false,
        };
        this.descripcionInputRef = React.createRef();
    };

    componentDidMount() {
        if (this.descripcionInputRef.current) {
            this.descripcionInputRef.current.focus();
        }
    }

    myChangeHandler = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    return = async (e) => {
        e.preventDefault();

        await this.props.fetchTipoUsuarios();

        this.props.navigate("/Usuarios/TipoUsuarios");
    }

    onSubmit = async (e) => {
        e.preventDefault();

        if (!this.state.descripcion || this.state.descripcion.trim() === "") {
            toast.error("La descripción es obligatoria.");
            return;
        }

        this.setState({ loading: true });

        const nuevoTipo = {
            descripcion: this.state.descripcion,
        };

        try {
            await postTiposUsuarios(nuevoTipo);
            toast.success("Tipo de usuario creado correctamente");
            setTimeout(() => {
                this.return(new Event("submit"));
            }, 300);

        } catch (error) {
            this.setState({ loading: false });

            if (error.response && error.response.data && error.response.data.errores) {
                const errores = error.response.data.errores;

                errores.forEach(err => {
                    toast.error(err);
                });

            } else {
                toast.error("Ocurrió un error inesperado al crear el tipo de usuario");
            }
        }
    };
    
    render() {

        return (

            <div className="col-sm-12">
                <div className="card">
                    <div className="card-body p-b-0">

                        <form className="form-horizontal form-material p-10" onSubmit={this.onSubmit}>
                            <div className="tab-content">

                                <div className='row align-items-center'>
                                    <div className="card-body p-b-5 d-flex align-items-center">
                                        <GoBackArrow />
                                        <h4 className="card-title ml-2">Nuevo Tipo de Usuario</h4>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <label className="label-oscura">Descripción</label>
                                            <input
                                                name="descripcion"
                                                type="text"
                                                onChange={this.myChangeHandler}
                                                class="form-control"
                                                ref={this.descripcionInputRef}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className='d-flex justify-content-center'>
                                    {
                                        this.state.loading ? <MiniSpinner /> : 
                                            <button
                                                type="submit"
                                                className="btn btn-sm background-rojo-megatone waves-light m-r-10"
                                            >
                                                Guardar
                                            </button>
                                    }



                                    <button onClick={this.return} class="btn btn-sm btn-light waves-effect waves-light">Cancelar</button>
                                </div>
                            </div>
                        </form>
                    </div>

                </div>
            </div>

        );
    }
}

export default connect(null, { fetchTipoUsuarios })(TipoUsuarioNuevoWrapper);